import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "flex gap-x-6" }
const _hoisted_3 = { class: "mt-1 mb-0.5 text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_4 = { class: "text-gray-lp-300 opacity-50 text-12px xxl:text-14px" }
const _hoisted_5 = { class: "mt-1 mb-0.5 text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_6 = { class: "text-gray-lp-300 opacity-50 text-12px xxl:text-14px" }
const _hoisted_7 = { class: "flex gap-x-6" }
const _hoisted_8 = { class: "flex gap-x-6" }
const _hoisted_9 = { class: "flex gap-x-6" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_11 = { class: "flex gap-x-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_13 = { class: "flex gap-x-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Title = _resolveComponent("Title")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        class: "w-6/12",
        label: _ctx.$t('claim.detail.createdAt')
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.createdAt), 1),
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.detailData.sttCreatedBy), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        class: "w-6/12",
        label: _ctx.$t('claim.detail.updatedAt')
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.updatedAt), 1),
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.detailData.sttUpdatedBy), 1)
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _createVNode(_component_Title, {
      label: _ctx.$t('claim.detail.deliveryDetail')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.noSTTGenesis'),
        class: "w-6/12",
        value: _ctx.detailData.sttNo
      }, null, 8, ["label", "value"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.shipmentID'),
        class: "w-6/12",
        value: _ctx.detailData.sttShipmentId
      }, null, 8, ["label", "value"])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.districtOriginCity'),
        class: "w-6/12",
        value: _ctx.detailData.sttOriginDistrictName
      }, null, 8, ["label", "value"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.districtDestinationCity'),
        class: "w-6/12",
        value: _ctx.detailData.sttDestinationDistrictName
      }, null, 8, ["label", "value"])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.externalRefNumber'),
        class: "w-6/12",
        value: _ctx.detailData.sttNoRefExternal
      }, null, 8, ["label", "value"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.bookedFor'),
        class: "w-6/12",
        value: _ctx.detailData.sttBookedFor
      }, null, 8, ["label", "value"])
    ]),
    _hoisted_10,
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.shipperName'),
        class: "w-6/12",
        value: _ctx.detailData.sttSenderName
      }, null, 8, ["label", "value"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.shipperPhoneNumber'),
        class: "w-6/12",
        value: _ctx.detailData.sttSenderPhone
      }, null, 8, ["label", "value"])
    ]),
    _createVNode(_component_DataWrapper, {
      class: "w-6/12",
      label: _ctx.$t('claim.detail.shipperAddress'),
      value: _ctx.detailData.sttSenderAddress
    }, null, 8, ["label", "value"]),
    _hoisted_12,
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.recipientName'),
        class: "w-6/12",
        value: _ctx.detailData.sttRecipientName
      }, null, 8, ["label", "value"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('claim.detail.recipientPhoneNumber'),
        class: "w-6/12",
        value: _ctx.detailData.sttRecipientPhone
      }, null, 8, ["label", "value"])
    ]),
    _createVNode(_component_DataWrapper, {
      class: "w-6/12",
      label: _ctx.$t('claim.detail.recipientAddress'),
      value: _ctx.detailData.sttRecipientAddress
    }, null, 8, ["label", "value"]),
    _createVNode(_component_DataWrapper, {
      class: "w-6/12",
      label: _ctx.$t('claim.detail.addressType'),
      value: 
        _ctx.detailData.sttRecipientAddressType.toLowerCase() === 'home'
          ? _ctx.$t('claim.detail.home')
          : _ctx.$t('claim.detail.office')
      
    }, null, 8, ["label", "value"])
  ]))
}